import http from '@/services/http';

const initialState = {
  roleActionMappings: {},
  myRoles: [],
};

/**
 * Load role action mappings from the backend.
 * @param state { Object } state for the account vuex context
 * @param commit { Object } commit for the account vuex context
 * @return { Object }
 */
async function loadRoleActionMappings({ state, commit }) {
  if (Object.keys(state.roleActionMappings).length !== 0) {
    return state.roleActionMappings;
  }
  const response = await http.getRoleActionMappings();
  if (response.data.status_code === 404) {
    throw new Error('No role action mappings found.');
  }
  if (response.data.status_code !== 200) {
    throw new Error(response.data.status_message || 'An error has occurred');
  }
  commit('setRoleActionMappings', response.payload.data);
  return state.roleActionMappings;
}

/**
 * Resets all roleActionMappings state
 */
function resetRoleActionMappings({ commit }) {
  commit('setRoleActionMappings', {});
}

/**
 * Load my roles from the backend.
 * @param state { Object } state for the account vuex context
 * @param commit { Object } commit for the account vuex context
 * @return { Object }
 */
async function loadMyRoles({ state, commit }) {
  if (Object.keys(state.myRoles).length !== 0) {
    return state.myRoles;
  }
  const response = await http.getMyRoles();
  if (response.data.status_code === 404) {
    throw new Error('No my roles action found.');
  }
  if (response.data.status_code !== 200) {
    throw new Error(response.data.status_message || 'An error has occurred');
  }
  commit('setMyRoles', response.payload.data);
  return state.myRoles;
}

/**
 * Resets the myRoles state
 */
function resetMyRoles({ commit }) {
  commit('setMyRoles', {});
}

export const actions = {
  loadRoleActionMappings,
  resetRoleActionMappings,
  loadMyRoles,
  resetMyRoles,
};

export const mutations = {
  setRoleActionMappings(state, payload) { state.roleActionMappings = payload; },
  setMyRoles(state, payload) { state.myRoles = payload; },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
